import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            First & Second Line Approval\n          ")
], -1);
const _hoisted_5 = { class: "mt-6" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", {
    for: "approval_comments",
    class: "block text-sm font-medium text-gray-700"
}, "Who provided HROps approval for this leaver?:", -1);
const _hoisted_7 = ["value", "disabled"];
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm" }, "The second line approver is the HR professional who will ensure all the correct policies and approvals have\n            been adhered to. If further approvals are required, they will co-ordinate this with the business outside the\n            system and keep records locally for audit purposes.\n        ", -1);
const _hoisted_9 = { class: "mt-6" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", {
    for: "second_line_date",
    class: "block text-sm font-medium text-gray-700"
}, "Approval date:", -1);
const _hoisted_11 = ["value", "disabled"];
import { inject } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LeaverApprovals',
    props: {
        data: {},
        disableForm: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const formatDate = inject('formatDate');
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                value: props.data?.leaver_notifyHROpsApproval?.approverEmail,
                                type: "text",
                                name: "approval_comments",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                disabled: _ctx.disableForm
                            }, null, 8, _hoisted_7)
                        ]),
                        _createTextVNode(),
                        _hoisted_8,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                value: _unref(formatDate)(props.data?.leaver_notifyHROpsApproval?.timeStamp, 'DD/MM/yyyy') === 'Invalid date' ?
                                    '' :
                                    _unref(formatDate)(props.data?.leaver_notifyHROpsApproval?.timeStamp, 'DD/MM/yyyy'),
                                type: "text",
                                name: "second_line_date",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                disabled: _ctx.disableForm
                            }, null, 8, _hoisted_11)
                        ])
                    ])
                ])
            ]));
        };
    }
});
